import magnifiAPIInstance from "./apiInstance";

export const streamAPIs = {
  getStreams: ({ payload }) => magnifiAPIInstance.post(`/streams/get`, payload),
  getStreamsByIds: ({ payload }) => magnifiAPIInstance.post(`/api/v3/get-stream-by-ids`, payload),
  getStreamDetails: ({ streamId }) => magnifiAPIInstance.get(`/streams/detail/${streamId}`),
  updateStream: ({ payload }) => magnifiAPIInstance.post(`/stream/update`, payload),
  reTriggerStream: ({ payload }) => magnifiAPIInstance.post(`/reprocess-video`, payload),
  exportJSONStream: ({ streamId, payload }) => magnifiAPIInstance.get(`/export-publish-clips/${streamId}`, payload),
  exportTimestampJSONStream: ({ streamId, payload }) =>
    magnifiAPIInstance.get(`/api/v1/export-timestamp-data/${streamId}`, payload),
  exportJSONStreamMetadata: ({ payload }) => magnifiAPIInstance.post(`/api/v2/partner/client/export-stream`, payload),
  exportStreamReport: ({ payload }) =>
    magnifiAPIInstance.post(`/stream/export/report`, payload, {
      headers: {
        "Content-Type": "text/plain;charset=UTF-8",
      },
    }),
  validateStreams: ({ payload }) => magnifiAPIInstance.post(`/validate-stream`, payload),
  exportEventsJSON: ({ streamId, payload }) => magnifiAPIInstance.post(`/export_events_json/${streamId}`, payload),
  exportStreamClipsXlsx: ({ streamId }) => magnifiAPIInstance.get(`/export-stream-clips/${streamId}`),
  getCopiedStreamCount: ({ streamId }) => magnifiAPIInstance.get(`/get-copied-stream-count/${streamId}`),
  getStreamClipFilters: ({ streamId, payload }) => magnifiAPIInstance.get(`/get-clips-filter/${streamId}`, payload),
  deleteStream: ({ payload }) => magnifiAPIInstance.post(`/streams/delete`, payload),
  getEventsByCategory: ({ payload }) => magnifiAPIInstance.post(`/get_event_by_category`, payload),
  getEventTagsById: ({ payload }) => magnifiAPIInstance.post(`/tags`, payload),
  getAllRatingRule: ({ payload }) =>
    magnifiAPIInstance.post(`/get-all-rating-rule`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    }),
  getLogsByType: ({ payload }) => magnifiAPIInstance.post(`/get/logger-by-type`, payload),
  initiateRequestForHLSToMP4: ({ payload }) => magnifiAPIInstance.post(`/initiate_request`, payload),
  getUsageCSVReport: ({ payload }) => magnifiAPIInstance.post(`/stream-highlights-clip-csv`, payload),
  validateStream: ({ payload }) => magnifiAPIInstance.post(`/stream/validation`, payload),
  getHLSToMP4VideoDetails: ({ streamId, payload }) => magnifiAPIInstance.get(`/get_hls_to_mp4/${streamId}`, payload),
  deleteHLSToMP4Data: ({ streamId, payload }) => magnifiAPIInstance.get(`/delete_hls_to_mp4_data/${streamId}`, payload),
  getStreamsListByUrl: ({ payload }) => magnifiAPIInstance.get(`/streams-by-url`, payload),
  sentToClientWebhook: ({ payload }) => magnifiAPIInstance.post(`/upload-stream-data`, payload),
  editStream: ({ payload }) => magnifiAPIInstance.post(`/streams/edit`, payload),
  createStream: ({ payload }) => magnifiAPIInstance.post(`/streams/create`, payload),
  createPreStreamTemplate: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/pre-stream-templates`, payload),
  getPreStreamTemplates: ({ entityId, payload }) =>
    magnifiAPIInstance.get(`/api/v3/entities/${entityId}/pre-stream-templates`, payload),
  updatePreStreamTemplate: ({ entityId, payload, templateId }) =>
    magnifiAPIInstance.put(`/api/v3/entities/${entityId}/pre-stream-templates/${templateId}`, payload),
  deletePreStreamTemplate: ({ entityId, templateId }) =>
    magnifiAPIInstance.delete(`/api/v3/entities/${entityId}/pre-stream-templates/${templateId}`),
  addClipNamingTemplateIdToStream: ({ payload }) =>
    magnifiAPIInstance.patch(`/clipNamingTemplate/addClipNamingTemplateIdToStream`, payload),
  getStreamDetailsByStreamId: ({ streamId, payload }) => magnifiAPIInstance.get(`/stream/get/${streamId}`, payload),
  getStreamClipSuggestions: ({ streamId, pageNo, search, ai_suggested_clips, ai_suggested_clips_filters }) =>
    magnifiAPIInstance.get(`/api/v1/clipSuggestion/${streamId}`, {
      params: { pageNo, limit: 10, search, ai_suggested_clips, ai_suggested_clips_filters },
    }),
  getStreamClipSuggestionsByTime: ({
    streamId,
    start_time,
    end_time,
    ai_suggested_clips,
    ai_suggested_clips_filters,
  }) =>
    magnifiAPIInstance.get(`/api/v1/clipSuggestion/get_by_time/${streamId}`, {
      params: { start_time, end_time, ai_suggested_clips, ai_suggested_clips_filters },
    }),
  saveStreamClipSuggestions: ({ payload }) => magnifiAPIInstance.post(`/api/v1/clipSuggestion`, payload),
  updateStreamClipSuggestions: ({ params, payload }) =>
    magnifiAPIInstance.put(`/api/v1/clipSuggestion`, payload, { params }),
  deleteStreamClipSuggestions: ({ payload }) =>
    magnifiAPIInstance.delete(`/api/v1/clipSuggestion`, { params: payload }),
  getStreamByClipId: ({ clipId }) => magnifiAPIInstance.get(`/api/v3/stream/get-by-clip-id/${clipId}`),
  getDatafeedStreams: ({ payload }) => magnifiAPIInstance.get(`/api/v3/streams/datafeed`, payload),
};
